import { render, staticRenderFns } from "./EnsSettingsModal.vue?vue&type=template&id=99f2e9b8&"
import script from "./EnsSettingsModal.vue?vue&type=script&lang=js&"
export * from "./EnsSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./EnsSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports